import endpointDuckFactory from "./_endpointDuckFactory";

const incidentCausesDuck = endpointDuckFactory({ endpoint: "incident-causes" });

export default incidentCausesDuck;
